import StarsInput from '@common/forms/fields/StarsInput'
import { useTranslate } from '@common/hooks'
import ModalWrapper from '@common/modals/ModalWrapper'
import Button from '@common/widgets/Button'
import { useState } from 'react'

import ModalForm from './ModalForm/ModalForm'
import classNames from './styles.module.scss'


export default function RatingForm(): JSX.Element {
  const { translate } = useTranslate()

  const [formRating, setFormRating] = useState(0)
  const [formIsOpen, setFormIsOpen] = useState(false)

  const handleOpenForm = (rating?: number) => () => {
    setFormRating(rating || 0)
    setFormIsOpen(true)
  }

  return (
    <section className={classNames.wrapper}>
      <h2 className={classNames.title} data-test="form-title">{translate('Rate this app')}</h2>
      <h5 className={classNames.subTitle} data-test="form-subtitle">{translate('Tell us what you think')}</h5>
      <div className={classNames.row}>
        <StarsInput onChange={handleOpenForm} value={formRating}/>
        <Button
          className={classNames.button}
          onClick={handleOpenForm()}
          data-test="form-btn"
        >
          {translate('Write a review')}
        </Button>
      </div>
      <ModalWrapper
        component={ModalForm}
        show={formIsOpen}
        onHide={() => {
          setFormIsOpen(false)
          setFormRating(0)
        }}
        size="lg"
        modalClassName={classNames.modal}
        initialValues={{ score: formRating }}
      />
    </section>
  )
}
